import { I18n } from '@app/i18n/strings-keys';
import {
  BehaviorSubject,
  rx,
  observableIIF,
  observableOf,
} from '@app/shared/rx';
import { WIDGET_COMPONENT } from '@app/shared/types/enums/widget-component.enum';
import { WIDGET_FAMILY } from '@config/global-constants';
import { isNil } from 'lodash';
import { Observable } from 'rxjs/Observable';
import { IReplenishApplyItemScopeOption } from '../../transfer-replenish/transfer-replenish.types';
import { REPLENISH_APPLY_ITEMS_SCOPE } from '../replenish.enums';
import { getReplenishItemScopeOptions } from '../replenish.utils';

const getReplenishItemOptions = (fieldItemOptions: {
  showItemOptions: boolean;
  itemOptionsClass: string;
  filtered$?: BehaviorSubject<boolean>;
}): {
  omit: boolean;
  title: string;
  widget: WIDGET_COMPONENT;
  widgetFamily: WIDGET_FAMILY;
  required: boolean;
  defaultValue: REPLENISH_APPLY_ITEMS_SCOPE;
  class: string;
  selectOptions: Observable<IReplenishApplyItemScopeOption[]>;
} => ({
  class: fieldItemOptions.itemOptionsClass,
  omit: !fieldItemOptions.showItemOptions,
  title: I18n.Forms.ReplenishForm.ItemOptions,
  widget: WIDGET_COMPONENT.select,
  widgetFamily: WIDGET_FAMILY.XUX,
  required: true,
  defaultValue: REPLENISH_APPLY_ITEMS_SCOPE.CHARGEABLE_ONLY,
  selectOptions: observableIIF(
    () => isNil(fieldItemOptions.filtered$),
    observableOf(false),
    fieldItemOptions.filtered$,
  ).pipe(rx.map((filtered: boolean) => getReplenishItemScopeOptions(filtered))),
});

export { getReplenishItemOptions };
